import {
  FIREBASE_PROVIDER_ANON,
  FIREBASE_PROVIDER_EMAIL,
  FIREBASE_PROVIDER_FACEBOOK,
  FIREBASE_PROVIDER_GITHUB,
  FIREBASE_PROVIDER_GOOGLE,
  FIREBASE_PROVIDER_TWITTER,
} from '@smart-maps/firebase';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import {
  FaFacebookSquare as FacebookIcon,
  FaGoogle as GoogleIcon,
  FaTwitter as TwitterIcon,
} from 'react-icons/fa';
import {
  GoGistSecret as AnonIcon,
  GoMail as MailIcon,
  GoMarkGithub as GithubIcon,
} from 'react-icons/go';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  avatar: {
    borderRadius: 46,
    composes: ['is-flex', 'is-relative', 'mb15', 'mt0'],
    height: 92,
    marginLeft: 'auto',
    marginRight: 'auto',
    width: 92,
  },
  icon: {
    verticalAlign: 'middle',
  },
  img: {
    borderRadius: 46,
    borderStyle: 'solid',
    borderWidth: 3,
    composes: ['margin-auto'],
    height: 92,
    width: 92,
  },
  social: {
    borderRadius: '50%',
    bottom: 0,
    color: '#FFFFFF',
    composes: ['is-absolute', 'text-center'],
    height: 32,
    left: '68%',
    lineHeight: '30px',
    width: 32,
  },
});

function getProviderIcon(providerid) {
  switch (providerid) {
    case FIREBASE_PROVIDER_GITHUB:
      return { Icon: GithubIcon, background: '#000000' };
    case FIREBASE_PROVIDER_GOOGLE:
      return { Icon: GoogleIcon, background: '#C94130' };
    case FIREBASE_PROVIDER_FACEBOOK:
      return { Icon: FacebookIcon, background: '#1092F3' };
    case FIREBASE_PROVIDER_TWITTER:
      return { Icon: TwitterIcon, background: '#1DA1F2' };
    case FIREBASE_PROVIDER_EMAIL:
      return { Icon: MailIcon, background: '#000000' };
    case FIREBASE_PROVIDER_ANON:
    default:
      return { Icon: AnonIcon, background: '#000000' };
  }
}

const ProfilePictureComponent = ({ photoURL, providerId }) => {
  const classes = useStyles();
  const { Icon, background } = getProviderIcon(providerId);
  return (
    <div className={classes.avatar}>
      <img
        alt="user avatar"
        className={classnames(classes.img, 'smart-maps-avatar')}
        src={photoURL}
      />
      <div className={classes.social} style={{ background }}>
        <Icon className={classes.icon} size={18} />
      </div>
    </div>
  );
};

ProfilePictureComponent.propTypes = {
  photoURL: PropTypes.string.isRequired,
  providerId: PropTypes.string.isRequired,
};

ProfilePictureComponent.displayName = 'ProfilePictureComponent';

export default ProfilePictureComponent;
